const isDto = (dtoKeys) => (dto) => dtoKeys.length === Object.keys(dto).length &&
    dtoKeys.every((key) => key in dto);
const baseSettingKeys = [
    'description',
    'settingId',
    'toolTip',
    'settingType',
];
const isSetting = (settingType, settingKeys) => (setting) => settingType === setting.settingType &&
    [...settingKeys, ...baseSettingKeys].length === Object.keys(setting).length &&
    [...settingKeys, ...baseSettingKeys].every((key) => key in setting);
export const isErrorMessageTO = isDto(['message']);
export const isSystemNotificationTO = isDto([
    'notification',
]);
export const isLobbyChatMessageTO = isDto([
    'message',
    'senderName',
]);
export const isChatNotificationTO = isDto(['message']);
export const isGameChatMessageTO = isDto([
    'gameId',
    'message',
    'senderName',
]);
export const isGameTypesTO = isDto(['gameTypes']);
export const isOpenGameListTO = isDto(['openGames']);
export const isGameNotificationTO = isDto([
    'gameId',
    'notification',
]);
export const isGameStateInformationTO = isDto([
    'gameId',
    'gameStateInformation',
]);
export const isGameActionTO = isDto(['gameId', 'action']);
export const isGameMessageTO = isDto(['gameId', 'message']);
export const isUsersOnlineTO = isDto(['usersOnline']);
export const isSettingsTO = isDto(['gameId', 'settings']);
export const isCheckBoxSetting = isSetting('checkbox', ['currentValue']);
export const isRadioButtonSetting = isSetting('radiobutton', [
    'currentValue',
    'strings',
]);
export const isTextFieldSetting = isSetting('text', [
    'currentValue',
    'maxLength',
]);
export const isDropDownSetting = isSetting('dropdown', [
    'currentValue',
    'strings',
]);
export const isSliderSetting = isSetting('slider', [
    'currentValue',
    'min',
    'max',
    'stepWidth',
]);
export const isDoubleSliderSetting = isSetting('doubleslider', [
    'currentValueLow',
    'currentValueHigh',
    'max',
    'max',
    'stepWidth',
]);
export const isGamePlayerActionTO = isDto([
    'action',
    'playerName',
]);
export const isHighscoreDataTO = isDto(['highscoreData']);
